import React from 'react'

type DeleteIconProps = {
  size?: number
}

export const DeleteIcon = ({ size = 14 }: DeleteIconProps) => (
  <svg
    fill='none'
    height={size}
    viewBox='0 0 10 10'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.45455 3.77273L5 6.22727M5 3.77273L7.45455 6.22727M8.68182 1.72727H3.36364L0.5 5L3.36364 8.27273H8.68182C8.89881 8.27273 9.10692 8.18653 9.26036 8.03309C9.4138 7.87965 9.5 7.67154 9.5 7.45455V2.54545C9.5 2.32846 9.4138 2.12035 9.26036 1.96691C9.10692 1.81347 8.89881 1.72727 8.68182 1.72727Z'
      stroke='currentColor'
      strokeWidth='1'
    />
  </svg>
)
